export const common = {
  common: {
    firstLoginHeading: 'Login successful!',
    firstLoginGreeting: 'Welcome to ',
    cancel: 'Cancel',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    restore: 'Restore',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    continue: 'Continue',
    save: 'Save',
    done: 'Done',
    home: 'Home',
    noData: 'No data.',
    confirm: 'Confirm',
    more: 'more',
    close: 'Close',
    loading: 'Loading',
    loaded: 'loaded',
    menu: 'Menu',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    create: 'Create',
    success: 'successful',
    error: 'Error',
    warning: 'Warning',
    move: 'move',
    update: 'rename',
    readArticle: 'Read article',
    toFaqs: "To the FAQ's",
    salutation: {
      female: 'Ms',
      male: 'Mr',
      diverse: 'Non-binary',
    },
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} result for {{query}}',
      title_plural: '{{count}} results for {{query}}',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_plural: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_plural: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'All products',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Loading...',
  },
  navigation: {
    shopAll: 'Shop all {{ navNode}} >',
  },
  searchBox: {
    placeholder: 'Search here...',
    ariaLabelInput: 'Search here...',
    ariaLabelSuggestions: 'typing suggestions',
    ariaLabelProducts: 'product results',
    initialDescription:
      'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
    suggestionsResult: '{{ count }} suggestion and ',
    suggestionsResult_plural: '{{ count }} suggestions and ',
    productsResult: '{{ count }} product is available.',
    productsResult_plural: '{{ count }} products are available.',
    resetLabel: 'Reset Search',
    help: {
      insufficientChars: 'Please type more characters',
      noMatch: 'We could not find any results',
      exactMatch: '{{ term }}',
      empty: 'Ask us anything',
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Order Number',
    rma: 'Return Number',
    replenishmentNumber: 'Replenishment Number',
    nextOrderDate: 'Next Order Date',
  },
  httpHandlers: {
    badGateway: 'A server error has occurred. Please try again later.',
    badRequestPleaseLoginAgain:
      'Unfortunately, that did not work. Please check that you are using the correct email address and password.',
    badRequestOldPasswordIncorrect: 'Old password incorrect.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} Email already exists. Please register with a different email address to sign up with a guest account.',
    conflict: 'Already exists.',
    forbidden:
      'You are not authorized to perform this action. Please contact your administrator if you believe this is an error.',
    gatewayTimeout: 'The server did not respond, please try again later.',
    internalServerError: 'An internal server error has occurred. Please try again later.',
    sessionExpired: 'Your session has expired. Please log in again.',
    unknownError: 'An unknown error has occurred',
    unauthorized: {
      common: 'An unknown authorization error has occurred',
      invalid_client: 'Bad client credentials',
    },
    validationErrors: {
      missing: {
        card_cardType: 'The selected credit card is not supported. Please select another.',
        card_accountNumber: 'The credit card number entered is not valid.',
        card_cvNumber: 'The security code entered is not valid.',
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        card_expirationYear: 'The credit card expiration date entered is not valid.',
        billTo_firstName: 'The first name entered is not valid.',
        billTo_lastName: 'The last name entered is not valid.',
        billTo_street1: 'The address entered is not valid.',
        billTo_street2: 'The address entered is not valid.',
        billTo_city: 'The city entered is not valid for this credit card.',
        billTo_state: 'The state/province entered is not valid for this credit card.',
        billTo_country: 'The country/region entered is not valid for this credit card.',
        billTo_postalCode: 'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Missing country/region',
        },
      },
      invalid: {
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        firstName: 'The first name entered is not valid.',
        lastName: 'The last name entered is not valid.',
        password: 'The password entered is invalid.',
        uid: 'Email is not valid.',
        code: 'Code is not valid.',
        email: 'Email is not valid.',
        login: 'Email is not valid.',
      },
    },
    cartNotFound: 'Cart not found.',
    invalidCodeProvided: 'Invalid code provided.',
  },
  miniCart: {
    item: '{{count}} item in your cart',
    item_plural: '{{count}} items in your cart',
    total: '{{total}}',
    count: '{{count}}',
  },
  skipLink: {
    skipTo: 'Skip to',
    labels: {
      header: 'Header',
      main: 'Main Content',
      footer: 'Footer',
      productFacets: 'Product Facets',
      productList: 'Product List',
    },
  },
  formErrors: {
    globalMessage: 'The form you are trying to submit contains errors.',
    required: 'Required field',
    maxLength40: 'The field is limited to 40 characters.',
    cxInvalidEmail: 'Please enter a valid email address.',
    cxInvalidPassword: 'This is not a valid password format',
    cxPasswordsMustMatch: 'Password fields must match',
    cxEmailsMustMatch: 'Email fields must match',
    cxStarRatingEmpty: 'Rating field is required',
    cxNoSelectedItemToCancel: 'Select at least one item',
    cxNegativeAmount: 'Amount must be equal or greater than zero',
    cxContainsSpecialCharacters: 'Field cannot contain special characters',
    date: {
      required: 'This field is required',
      min: 'Date cannot be before {{min}}',
      max: 'Date cannot be after {{max}}',
      pattern: 'Use dateformat yyyy-mm-dd',
      invalid: 'Use a valid date',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'Failed to load the script.',
    refreshThePage: 'Please refresh the page.',
  },
};
